import { useEffect, useState } from 'react';
import { forwardRef, useImperativeHandle } from "react"
import { decodeWinData } from "./win.js";
import { calcspectrum, hzarray}  from "./fft.js"
import WinGraph from "./wingraph.js"
import SpcGraph from "./spcgraph.js"

const Wingraphs = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        download() { csvdownload() }
    }))
    const [data, setdata] = useState([]);
    const [maxval, setMaxval] = useState(0);
    const [maxspc, setMaxspc] = useState(0);

    function adjustacc(winObj) {
        for (var i=0; i < winObj.x.length; i++ ) {
            var avg1 = 0;
            var avg2 = 0;
            var avg3 = 0;
            for (var j = 0; j < winObj.x[i].length; j++) {
                avg1 += winObj.x[i][j];
                avg2 += winObj.y[i][j];
                avg3 += winObj.z[i][j];
            }
            avg1 = avg1 / winObj.x[i].length;
            avg2 = avg2 / winObj.y[i].length;
            avg3 = avg3 / winObj.z[i].length;
            for (j = 0; j < winObj.x[i].length; j++) {
                winObj.x[i][j] = winObj.x[i][j] - avg1;
                winObj.y[i][j] = winObj.y[i][j] - avg2;
                winObj.z[i][j] = winObj.z[i][j] - avg3;
            }
        }
        return winObj;
    }

    function formatDate(datetime) {
        if (datetime == null) return null;
        const modified = new Date(datetime);
        const year = modified.getFullYear();
        const month = ("0" + (modified.getMonth() + 1)).slice(-2);
        const date = ("0" + modified.getDate()).slice(-2);
        const hours = ("0" + modified.getHours()).slice(-2);
        const minutes = ("0" + modified.getMinutes()).slice(-2);
        const seconds = ("0" + modified.getSeconds()).slice(-2);
        const mseconds = ("0000" + modified.getMilliseconds()).slice(-3);
        return year + "-" + month + "-" + date + "T" + hours + ":" + minutes + ":" + seconds + "." + mseconds;
    };

    function csvdownload() {
        const isodate = formatDate(new Date(data[0]["win"]["tsX"][0]));
        const filename = "acc_" + isodate.substring(0,4) + isodate.substring(5,7) + isodate.substring(8,10) + isodate.substring(11,13) + isodate.substring(14,16) + ".csv"
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        var csv = "isotime,";
        for (var i=0; i < data.length ; i++) {
            var sname = props.names[i]; 
            csv += ("accX_" + sname + "[gal],accY_"  + sname +  "[gal],accZ_"  + sname +  "[gal],");
        }
        csv = csv.slice( 0, -1 ) + "\n";
        for ( i=0; i < data[0]["win"]["x"].length ; i++) {
            const date = new Date(data[0]["win"]["tsX"][i]);
            var line = formatDate(date) + ",";
            for (var j=0; j < data.length ; j++) {
                line += (data[j]["win"]["x"][i] + "," + data[j]["win"]["y"][i] + "," + data[j]["win"]["z"][i] + ",");
            }
            csv += line.slice( 0, -1 ) + "\n";
        }
        const blob = new Blob([bom, csv], { type: "text/csv" })
        const link = document.createElement('a')
        link.download = filename
        link.href = URL.createObjectURL(blob)
        link.click()
        URL.revokeObjectURL(link.href)
    }

    useEffect(() => {
        if (props.win) {
            let winObj = adjustacc(decodeWinData(props.win));
            var dataObjs = [];
            var win = {};
            var spc = {};
            var amaxspc = 0;
            var amaxval = 0;
            for (var i = 0; i < winObj.x.length; i++) {
                win = {
                    x: winObj.x[i], y: winObj.y[i], z: winObj.z[i],
                    tsX: winObj.tsX[i], tsY: winObj.tsY[i], tsZ: winObj.tsZ[i],
                }
                var x = calcspectrum(winObj.x[i]); 
                var y = calcspectrum(winObj.y[i]);
                var z = calcspectrum(winObj.z[i]);
                var hz = hzarray(x,100);
                spc = {
                    x: x, y: y, z: z,
                    hzX: hz, hzY: hz, hzZ: hz,
                }
                dataObjs.push({win: win, spc: spc});
                var idx=0;
                for (; idx < hz.length; idx++) {
                    if ( hz[idx] >= 0.1 ) break;
                }
                amaxspc = Math.max(...x.slice(idx),...y.slice(idx),...z.slice(idx),amaxspc)
                const xmax = Math.max(Math.max(...winObj.x[i]), Math.abs(Math.min(...winObj.x[i])));
                const ymax = Math.max(Math.max(...winObj.y[i]), Math.abs(Math.min(...winObj.y[i])));
                const zmax = Math.max(Math.max(...winObj.z[i]), Math.abs(Math.min(...winObj.z[i])));
                amaxval = Math.max(xmax,ymax,zmax,amaxval)
            }
            setdata(dataObjs);
            setMaxval(amaxval);
            setMaxspc(amaxspc);
        }
    } , [props.win])
    
    return (
        <div>
            {data.map((onedata,idx) => {
                return (
                    <div>
                    {props.names[idx]}
                    <div key={idx} style={{ display: "flex", flexWrap: "wrap"}}>
                        <div style={{width:"50%", padding: "4px"}}>
                            <WinGraph windata={onedata.win} height={props.height} unit={"加速度(gal)"} maxval={maxval}/>
                        </div>
                        <div style={{width:"50%", padding: "4px"}}>
                            <SpcGraph windata={onedata.spc} height={props.height} maxval={maxspc}/>
                        </div>
                    </div>
                    </div>
                )
            })}
        </div>
    );
})

export default Wingraphs;

